import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  onDismiss?: () => void;
  variant?: 'error' | 'warning' | 'info';
  icon?: React.ReactNode;
  className?: string;
}

export default function ErrorMessage({
  message,
  action,
  onDismiss,
  variant = 'error',
  icon,
  className = '',
}: ErrorMessageProps) {
  const defaultIcon = variant === 'error' ? '❌' : variant === 'warning' ? '⚠️' : 'ℹ️';

  return (
    <div className={`error-message error-message-${variant} ${className}`}>
      <div className="error-message-content">
        <span className="error-message-icon">{icon || defaultIcon}</span>
        <span className="error-message-text">{message}</span>
      </div>
      <div className="error-message-actions">
        {action && (
          <button
            className="error-message-action-button"
            onClick={action.onClick}
            type="button"
          >
            {action.label}
          </button>
        )}
        {onDismiss && (
          <button
            className="error-message-dismiss-button"
            onClick={onDismiss}
            type="button"
            aria-label="Cerrar"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}

interface ErrorListProps {
  errors: string[];
  title?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorList({ errors, title = 'Errores encontrados', onRetry, className = '' }: ErrorListProps) {
  if (errors.length === 0) return null;

  return (
    <div className={`error-list ${className}`}>
      <div className="error-list-header">
        <h3 className="error-list-title">⚠️ {title}</h3>
        {onRetry && (
          <button className="error-list-retry-button" onClick={onRetry} type="button">
            Reintentar
          </button>
        )}
      </div>
      <ul className="error-list-items">
        {errors.map((error, index) => (
          <li key={index} className="error-list-item">
            {error}
          </li>
        ))}
      </ul>
    </div>
  );
}

